import React, { Component } from "react";
import { Col, Row, TabContent, TabPane, Spinner, ListGroup, ListGroupItem} from "reactstrap";
import { Doughnut } from 'react-chartjs-2';
import "./UserActivity.scss";
const moment = require("moment-timezone");
class UserInfo extends Component {
  constructor(props) {
    super(props);
    this.getLifetime = this.getLifetime.bind(this)
    this.generateChart = this.generateChart.bind(this)
    this.getTopIntent = this.getTopIntent.bind(this)
    this.getUserTypeIcon = this.getUserTypeIcon.bind(this)
    this.state = {
      userId: this.props.userId,
      guid: this.props.guid,
      userType: "",
      time: null,
      topIntents:[],
      metadata: this.props.metadata,
      tasks: this.props.taskData,
      lifetime: "Unavailable",
      doughnut: {},
      legend: []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.userId !== this.props.userId ||
      nextProps.visible !== this.props.visible
    ) {
      this.setState({
        userId: nextProps.userId,
        visible: nextProps.visible,
      });
    }
  }

  getUserTypeIcon(isRepeatUser)
  {
    if(isRepeatUser)
    {
      return(
        <img src='no-error.png' className="no-error-png"></img>
      )
    }
    else{
      return(
      
        <img src='repeat-false.png' className="no-error-png"></img>
      )
    }
  }

  getTopIntent(range)
  {
    let intents = this.props.userIntents.sort((intentA,intentB)=> (intentA.total < intentB.total)? 1 : -1)
    
    return intents.map(x=>x.intent).slice(0,range).join(", ")

  }

  generateChart()
  {
    if(this.props.intentsLoading) {
      return (
        <div className="loadingSpinner">
          <Spinner color="info" />
        </div>
      )
    }
    //order intents
    let intents = this.props.userIntents.sort((intentA,intentB)=> (intentA.total < intentB.total)? 1 : -1)

    let set1 = intents.slice(0,8)

    //combine rest of intents into "other" if more than 8 user intents
    if(intents.length>9)
    {
    let set2 = intents.slice(8)
    let otherSum = set2.map((intent) => intent.total).reduce((total, a) => total + a)
    let otherIntents = set2.map((intent) => intent.intent).join('\n')
    let otherIntentObj = {intent: `Other`, total: otherSum}
    set1.push(otherIntentObj)
    }


    let doughnut = {
      labels: set1.map(intentObj => intentObj.intent),
      datasets: [
        {
          data: set1.map(intentObj =>intentObj.total),
          backgroundColor: [
            '#F2A76F',
            '#7172AD',
            '#F9D45C',
            '#6450E3',
            '#509EE3',
            '#BE8CEF',
            '#98D8D9',
            '#5CC2F9',
            '#B5FA5C',
            '#C7CFD4',
           ],
          hoverBackgroundColor: [
            '#F2A76F',
            '#7172AD',
            '#F9D45C',
            '#6450E3',
            '#509EE3',
            '#BE8CEF',
            '#98D8D9',
            '#5CC2F9',
            '#B5FA5C',
            '#C7CFD4',
           ]
        }]
    };
    

    return <Doughnut data={doughnut}  options={{legend:{ display: true, position: 'bottom' }}}/>
  }
  

  getLifetime(){
    let timeStart = this.props.metadata.FirstEngagement.firstTimestamp
    if(timeStart >0)
    {
      let lifeTime = Math.round((Date.now()-timeStart)/86400000);
      return  lifeTime === 0 || lifeTime === 1 ? 1 + ' day' : lifeTime + ' days'
    }
    else{
      return "Unavailable"
    } 
  }


  render() {
    if (this.state.userId !== null && this.props.metadata !== null) {
      return (
        <TabContent className="user-info-tab" id="user-info-tab">
          <TabPane className="user-info-tab-pane">
            <Row>
              <Col sm="5" className="tab-pane-col">
                <ListGroup className="metadata-list" >
                    <ListGroupItem>
                      <Row>
                        <Col className="metadata-col" md="5">
                          User Id
                        </Col>
                        <Col md="7">
                        {this.state.userId} 
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Pref. Language
                        </Col>
                        <Col md="7">
                        {this.props.metadata.preferredLang}
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Last Task
                        </Col>
                        <Col md="7">
                        {this.props.taskData.data.lastCompleted? this.props.taskData.data.lastCompleted.name : "None"}
                        </Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Incomplete Task
                        </Col>
                        <Col md="7">
                        {this.props.taskData.data.lastIncomplete? this.props.taskData.data.lastIncomplete.name : "None" }
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Last Engagement
                        </Col>
                        <Col md="7">
                        {moment.tz(parseInt(this.props.metadata.LastEngagementDetails.lastTimestamp), this.props.settings.timezone).format("MM/DD, h:mm A")}
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Preferred Channel
                        </Col>
                        <Col md="7">
                        {this.props.metadata.Channels.preferredChannel}
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Repeat User
                        </Col>
                        <Col md="7">
                        {this.getUserTypeIcon(this.props.metadata.RepeatUser)}
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Channels Used
                        </Col>
                        <Col md="7">
                        {Array.from(this.props.metadata.Channels.channelsUsed.map((x)=>x.name)).join(", ")} 
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Most Used Intents:
                        </Col>
                        <Col md="7">
                        {this.getTopIntent(3)}
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        First Seen
                        </Col>
                        <Col md="7">
                        {moment
                          .tz(
                            parseInt(this.props.metadata.FirstEngagement.firstTimestamp),
                            this.props.settings.timezone
                          )
                          .format("MM/DD, h:mm A")}
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Last Seen
                        </Col>
                        <Col md="7">
                        {moment
                          .tz(
                            parseInt(this.props.metadata.LastEngagementDetails.lastTimestamp),
                            this.props.settings.timezone
                          )
                          .format("MM/DD, h:mm A")}
                        </Col>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Row>
                        <Col md="5" className="metadata-col">
                        Lifetime
                        </Col>
                        <Col md="7">
                        {this.getLifetime()}
                        </Col>
                      </Row>
                    </ListGroupItem>
                </ListGroup>
              </Col>
              <Col xs="7">
                <b>User Intents:</b>
                {this.generateChart()}
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      );
    } else
      return (
        <TabContent className="tab-content">
        </TabContent>
      );
  }
}

export default UserInfo;
